import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {DashboardLayout} from '../../../../../components';
import {
  arrowLeftDark,
  chevronRight,
  easyOnboardIc,
} from '../../../../../assets/images/images';
import {PAGES_URL} from '../../../../../helpers/constants';
import CategorySection from './CategorySection';

const RulesWrapper = ({children}) => {
  const location = useLocation();

  const getButtonClass = route =>
    location.pathname === route ? 'bg-white' : '';

  return (
    <DashboardLayout
      bg="bg-white80"
      xlLeftMargin="xl:ml-12 !ml-0 !pt-0"
      xlRightPadding="!pr-0"
      breadCrumbs={
        <div className="flex items-center">
          <img src={easyOnboardIc} alt="" />
          <p className="ml-2 -mb-1">Fraud detection</p>
          <img src={chevronRight} alt="" width={18} height={18} />
          <p className="-mb-1">Flows</p>
          <img src={chevronRight} alt="" width={18} height={18} />
          <p className="-mb-1">Cases</p>
        </div>
      }
    >
      <div className="grid lg:grid-cols-[56%,44%] min-h-[600px] mt-16 lg:mt-0">
        <div className="border border-transparent mx-5 lg:mx-0 lg:border-r-[#E1E4EA] bg-white lg:py-8 lg:px-10">
          <button className="flex items-center gap-2 mt-5 lg:mt-0">
            <img src={arrowLeftDark} alt="Back" width={16} height={16} />
            <p className="-mb-1 text-base text-black">Processes</p>
          </button>

          <div className="h-[1px] w-full bg-[#e1e4ea] my-5 hidden lg:block" />

          <div className="my-5 border w-fit border-[#e1e4ea] rounded-xl bg-[#f7f7f7] p-1 flex items-center gap-2">
            <Link
              to={PAGES_URL.FLOWS_CASES_INDIVIDUAL}
              className={`py-[10px] px-4 text-tiny font-medium   rounded-xl ${getButtonClass(
                PAGES_URL.FLOWS_CASES_INDIVIDUAL,
              )}`}
            >
              Individual accounts
            </Link>
            <Link
              to={PAGES_URL.FLOWS_CASES_CORPORATE}
              className={`py-[10px] px-4 text-tiny font-medium   rounded-xl ${getButtonClass(
                PAGES_URL.FLOWS_CASES_CORPORATE,
              )}`}
            >
              Corporate accounts
            </Link>
            <Link
              to={PAGES_URL.FLOWS_CASES_BEHAVIOURAL_MONITORING}
              className={`py-[10px] px-4 text-tiny font-medium   rounded-xl ${getButtonClass(
                PAGES_URL.FLOWS_CASES_BEHAVIOURAL_MONITORING,
              )}`}
            >
              Behavioral monitoring
            </Link>
          </div>

          <div>{children}</div>
        </div>

        <div className="lg:px-10 pt-12 mx-5 lg:mx-0">
          <CategorySection />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default RulesWrapper;
